import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaTimes } from "react-icons/fa";
import { BiVideo } from "react-icons/bi";
import {
  MdOutlineGroups,
  MdOutlineManageAccounts,
  MdOutlineOndemandVideo,
  MdOutlinePerson,
  MdOutlineSpaceDashboard, MdOutlineWorkspacePremium
} from "react-icons/md";
import { FaUserCog } from "react-icons/fa";
import { FaBookMedical } from "react-icons/fa";
import { IoWarningOutline } from "react-icons/io5";
import { BsFileEarmarkCheckFill } from "react-icons/bs";
import { PiFilesLight } from "react-icons/pi";
import { RxDashboard } from "react-icons/rx";
import { FaAngleUp, FaAngleDown } from "react-icons/fa6";
import { GiProgression } from "react-icons/gi";
import { MdOutlineDocumentScanner } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { getOrganizationById } from "../../store/reducers/organizationSlice";
import { FaBook, FaBookReader, FaRegQuestionCircle } from "react-icons/fa";

const UserMenuSidebar = ({ toggleMenuSidebar }) => {
  const [t] = useTranslation();
  const [badgesOpen, setBadgesOpen] = useState(false);
  const [employeePdfsOpen, setEmployeePdfsOpen] = useState(false);
  const dispatch = useDispatch();
  const { customPoints } = useSelector((state) => state.badgesDetails);
  const { organizationDetails, selectedOrganization } = useSelector(
    (state) => state.organization,
  );

  const allAccess =
    !customPoints || !Array.isArray(customPoints.reward_permission);

  const canAccessScoreboard =
    allAccess || customPoints.reward_permission.includes("scoreboard");
  const canAccessLeaderboard =
    allAccess || customPoints.reward_permission.includes("leader_board");
  const canAccessEmployeePerformance =
    allAccess ||
    customPoints.reward_permission.includes("employee_performance");
  const canAccessBadges =
    allAccess || customPoints.reward_permission.includes("badges");

  const { organizations } = useSelector((state) => state.userOrganizations);
  const isAdmin_Owner = organizations.some((org) => {
    const orgRole = `${org.role || ""}`.toLowerCase();

    return (
      org.organisation_id === +localStorage.getItem("organisation_id") &&
      (orgRole === "admin" || orgRole === "owner")
    );
  });

  const role = localStorage.getItem("user_role");
  const normalizedRole = `${role || ""}`.toLowerCase();
  const isOwner_Admin =
    normalizedRole === "admin" || normalizedRole === "owner";
  const isExternalInstructor = organizations.some(
    (org) =>
      org.organisation_id === +localStorage.getItem("organisation_id") &&
      org.role === "External Instructor"
  );
  const activeOrganisationId =
    selectedOrganization?.organisation_id ||
    localStorage.getItem("organisation_id");
  const activeCustomerId =
    selectedOrganization?.customer_id || localStorage.getItem("customer_id");
  const canViewHRManagement = ["17", "144"].includes(String(activeCustomerId));
  const organizationLogo = organizationDetails?.logo || "";
  const hasCustomLogo = Boolean(organizationLogo);
  const defaultSidebarLogo = "/img/Logo_negative.svg";
  const [isOrganizationLogoLoaded, setIsOrganizationLogoLoaded] =
    useState(false);
  const sidebarLogo =
    hasCustomLogo && isOrganizationLogoLoaded
      ? organizationLogo
      : defaultSidebarLogo;

  useEffect(() => {
    const detailsOrganisationId =
      organizationDetails?.id || organizationDetails?.organisation_id;

    if (
      activeOrganisationId &&
      String(detailsOrganisationId || "") !== String(activeOrganisationId)
    ) {
      dispatch(getOrganizationById(activeOrganisationId));
    }
  }, [activeOrganisationId, organizationDetails, dispatch]);

  useEffect(() => {
    const pathsToOpen = [
      "/badges_dashboard",
      "/badges",
      "/leaderboard",
      "/employee-progress",
      "/employee-progress/:id",
    ];
    const currentPath = window.location.pathname;
    const isDynamicEmployeeProgress = /^\/employee-progress\/[^/]+$/.test(
      currentPath,
    );
    if (pathsToOpen.includes(currentPath) || isDynamicEmployeeProgress) {
      setBadgesOpen(true);
    } else {
      setBadgesOpen(false);
    }
  }, [window.location.pathname]);

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (
      currentPath === "/general-instruction-pdfs" ||
      currentPath === "/general-instruction-pdfs/manage"
    ) {
      setEmployeePdfsOpen(true);
    } else {
      setEmployeePdfsOpen(false);
    }
  }, [window.location.pathname]);

  useEffect(() => {
    if (!hasCustomLogo) {
      setIsOrganizationLogoLoaded(false);
      return;
    }

    setIsOrganizationLogoLoaded(false);

    const logoImage = new Image();
    logoImage.src = organizationLogo;
    logoImage.onload = () => setIsOrganizationLogoLoaded(true);
    logoImage.onerror = () => setIsOrganizationLogoLoaded(false);

    return () => {
      logoImage.onload = null;
      logoImage.onerror = null;
    };
  }, [hasCustomLogo, organizationLogo]);

  return (
    <aside className="main-sidebar bg-bg_color bg_color elevation-5">
      <div className="sidebar">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div className="user-sidebar mt-3 pb-3 mb-3 d-flex">
            <NavLink
              to="/"
              className="text-center"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: "transparent",
                  width: "100%",
                  maxWidth: hasCustomLogo ? "220px" : "unset",
                  height: hasCustomLogo ? "72px" : "35px",
                  paddingTop: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: hasCustomLogo ? "hidden" : "visible",
                  margin: "0 auto",
                }}
              >
                <img
                  src={sidebarLogo}
                  alt="logo"
                  style={{
                    maxWidth:
                      hasCustomLogo && isOrganizationLogoLoaded
                        ? "100%"
                        : "80%",
                    maxHeight:
                      hasCustomLogo && isOrganizationLogoLoaded
                        ? "100%"
                        : "none",
                    width:
                      hasCustomLogo && isOrganizationLogoLoaded
                        ? "auto"
                        : "80%",
                    height: "auto",
                    objectFit:
                      hasCustomLogo && isOrganizationLogoLoaded
                        ? "contain"
                        : "initial",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              </div>
            </NavLink>
          </div>

          {/* Close button - visible only on mobile */}
          <div className="d-block d-md-none text-right p-1 mt-3">
            <button
              onClick={toggleMenuSidebar}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "1rem",
                cursor: "pointer",
                color: "var(--org-font-color, #fff)",
              }}
            >
              <FaTimes />
            </button>
          </div>
        </div>

        <nav className="mt-6" style={{ width: "100%" }}>
          <ul
            className="nav nav-pill nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            <li className="nav-item">
              <NavLink to="/dashboard" exact className="nav-link">
                <MdOutlineSpaceDashboard size={24} />
                <p className="ml-2">
                  {t("userMenuSidebar.label.AC-Analytics")}
                </p>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink to="/new-ac-analytics" exact className="nav-link">
                <IoWarningOutline size={24} />
                <p className="ml-2">
                  {t("userMenuSidebar.label.RiskAnalysis")}
                </p>
              </NavLink>
            </li>

            {canViewHRManagement && (
              <li className="nav-item">
                <NavLink to="/hr-management" exact className="nav-link">
                  <MdOutlineGroups size={24} />
                  <p className="ml-2">
                    {t("userMenuSidebar.label.HR-management")}
                  </p>
                </NavLink>
              </li>
            )}

            <li className="nav-item">
              <NavLink to="/instruction-video" exact className="nav-link">
                <BiVideo size={24} />
                <p className="ml-2">
                  {t("userMenuSidebar.label.InstructionVideos")}
                </p>
              </NavLink>
            </li>

            {organizationDetails?.view_educational_videos && (
              <li className="nav-item">
                <NavLink to="/educational-videos" exact className="nav-link">
                  <MdOutlineOndemandVideo size={24} />
                  <p className="ml-2">
                    {t("userMenuSidebar.label.Educational_video")}
                  </p>
                </NavLink>
              </li>
            )}

            {organizationDetails?.view_ac_online && (
              <li className="nav-item">
                <NavLink to="/view-ac-cards" exact className="nav-link">
                 <FaBookMedical size={24} />
                  <p className="ml-2"> {t("userMenuSidebar.label.View_AC")}</p>
                </NavLink>
              </li>
            )}

            <li className="nav-item">
              <NavLink to="/quizzes" exact className="nav-link">
                <FaRegQuestionCircle size={22} />
                <p className="ml-2"> {t("userMenuSidebar.label.Quizzes")}</p>
              </NavLink>
            </li>

            
            <li className="nav-item">
              <div
                className="nav-link d-flex align-items-center justify-content-between"
                style={{ cursor: "pointer" }}
                onClick={() => setBadgesOpen((open) => !open)}
              >
                <span className="d-flex align-items-center">
                  <MdOutlineWorkspacePremium size={24} />
                  <span>
                    <span className="ml-2">
                      {t("userMenuSidebar.label.Award_menu")}
                    </span>
                    <span className="ml-2" style={{ fontSize: "10px" }}>
                      (BETA)
                    </span>
                  </span>
                </span>
                <span>
                  {badgesOpen ? (
                    <FaAngleUp size={18} />
                  ) : (
                    <FaAngleDown size={18} />
                  )}
                </span>
              </div>
              {badgesOpen && (
                <ul
                  className="nav nav-pill nav-sidebar flex-column"
                  data-widget="treeview"
                  role="menu"
                  data-accordion="false"
                >
                  {canAccessScoreboard && (
                    <li className="nav-item">
                      <NavLink
                        to="/badges_dashboard"
                        className="nav-link"
                        style={{ paddingLeft: "2rem" }}
                      >
                        <RxDashboard size={18} className="mr-2" /> Scoreboard
                      </NavLink>
                    </li>
                  )}
                  {(isAdmin_Owner || isOwner_Admin) &&
                    canAccessEmployeePerformance && (
                      <li>
                        <NavLink
                          to="/employee-progress"
                          className={({ isActive, location }) => {
                            const path =
                              location?.pathname || window.location.pathname;
                            const match =
                              path === "/employee-progress" ||
                              /^\/employee-progress\/(\d+|[^/]+)$/.test(path);
                            return `nav-link${match ? " active" : ""}`;
                          }}
                          style={{ paddingLeft: "2rem" }}
                        >
                          <GiProgression size={18} className="mr-2" /> Employee
                          Performance
                        </NavLink>
                      </li>
                    )}
                  {canAccessBadges && (
                    <li>
                      <NavLink
                        to="/badges"
                        className="nav-link"
                        style={{ paddingLeft: "2rem" }}
                      >
                        <MdOutlineWorkspacePremium size={18} className="mr-2" /> Badges
                      </NavLink>
                    </li>
                  )}
                  {canAccessLeaderboard && (
                    <li>
                      <NavLink
                        to="/leaderboard"
                        className="nav-link"
                        style={{ paddingLeft: "2rem" }}
                      >
                        <BsFileEarmarkCheckFill size={18} className="mr-2" />{" "}
                        Leaderboard
                      </NavLink>
                    </li>
                  )}
                </ul>
              )}
            </li>

            {organizationDetails?.view_employee_pdfs && (
              <li className="nav-item">
                <div
                  className="nav-link d-flex align-items-center justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() => setEmployeePdfsOpen((open) => !open)}
                >
                  <span className="d-flex align-items-center">
                    <FaBook size={22} />
                    <span className="ml-2">General Instruction PDFs</span>
                  </span>
                  <span>
                    {employeePdfsOpen ? (
                      <FaAngleUp size={18} />
                    ) : (
                      <FaAngleDown size={18} />
                    )}
                  </span>
                </div>
                {employeePdfsOpen && (
                  <ul
                    className="nav nav-pill nav-sidebar flex-column"
                    data-widget="treeview"
                    role="menu"
                    data-accordion="false"
                  >
                    <li className="nav-item">
                      <NavLink
                        to="/general-instruction-pdfs"
                        exact
                        className="nav-link"
                        style={{ paddingLeft: "2rem" }}
                      >
                        <FaBookReader size={18} className="mr-2" />
                        View PDFs
                      </NavLink>
                    </li>

                    {(isAdmin_Owner || isOwner_Admin) && (
                      <li className="nav-item">
                        <NavLink
                          to="/general-instruction-pdfs/manage"
                          exact
                          className="nav-link"
                          style={{ paddingLeft: "2rem" }}
                        >
                          <MdOutlineDocumentScanner
                            size={18}
                            className="mr-2"
                          />
                          Manage PDFs
                        </NavLink>
                      </li>
                    )}
                  </ul>
                )}
              </li>
            )}

            {!isExternalInstructor && (
              <li className="nav-item">
                <NavLink
                  to="/incident_reports_and_documentation"
                  exact
                  className="nav-link"
                >
                  <PiFilesLight size={24} />
                  <p className="ml-2">
                    {t(
                      "userMenuSidebar.label.Incident_reports_and_documentation"
                    )}
                  </p>
                </NavLink>
              </li>
            )}

            {(isAdmin_Owner || isOwner_Admin) && (
              <li className="nav-item">
                <NavLink to="/administration" exact className="nav-link">
                  <FaUserCog size={24} />
                  <p className="ml-2">
                    {t("userMenuSidebar.label.Administration")}
                  </p>
                </NavLink>
              </li>
            )}

            <li className="nav-item">
              <NavLink to="/account-details" exact className="nav-link">
                <MdOutlinePerson size={24} />
                <p className="ml-2">
                  {t("userMenuSidebar.label.AccountDetails")}
                </p>
              </NavLink>
            </li>   

            {localStorage.getItem("type") === "Private" ? null : (
              <li className="nav-item">
                <NavLink to="/change-org" exact className="nav-link">
                  <MdOutlineManageAccounts size={24} />
                  <p className="ml-2">{t("userMenuSidebar.label.ChangeOrg")}</p>
                </NavLink>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default UserMenuSidebar;
